import { MetricKeyTypeId as MetricKeyTypeId$1, isMetricKey as isMetricKey$1, counter as counter$1, frequency as frequency$1, gauge as gauge$1, histogram as histogram$1, summary as summary$1, tagged as tagged$1, taggedWithLabels as taggedWithLabels$1, taggedWithLabelSet as taggedWithLabelSet$1 } from '../../internal/metric/key.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricKeyTypeId = MetricKeyTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `MetricKey` is a unique key associated with each metric. The key is based
 * on a combination of the metric type, the name and tags associated with the
 * metric, an optional description of the key, and any other information to
 * describe a metric, such as the boundaries of a histogram. In this way, it is
 * impossible to ever create different metrics with conflicting keys.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
const isMetricKey = isMetricKey$1;

/**
 * Creates a metric key for a counter, with the specified name.
 *
 * @since 2.0.0
 * @category constructors
 */
const counter = counter$1;

/**
 * Creates a metric key for a categorical frequency table, with the specified
 * name.
 *
 * @since 2.0.0
 * @category constructors
 */
const frequency = frequency$1;

/**
 * Creates a metric key for a gauge, with the specified name.
 *
 * @since 2.0.0
 * @category constructors
 */
const gauge = gauge$1;

/**
 * Creates a metric key for a histogram, with the specified name and boundaries.
 *
 * @since 2.0.0
 * @category constructors
 */
const histogram = histogram$1;

/**
 * Creates a metric key for a summary, with the specified name, maxAge,
 * maxSize, error, and quantiles.
 *
 * @since 2.0.0
 * @category constructors
 */
const summary = summary$1;

/**
 * Returns a new `MetricKey` with the specified tag appended.
 *
 * @since 2.0.0
 * @category constructors
 */
const tagged = tagged$1;

/**
 * Returns a new `MetricKey` with the specified tags appended.
 *
 * @since 2.0.0
 * @category constructors
 */
const taggedWithLabels = taggedWithLabels$1;

/**
 * Returns a new `MetricKey` with the specified tags appended.
 *
 * @since 2.0.0
 * @category constructors
 */
const taggedWithLabelSet = taggedWithLabelSet$1;

export { MetricKeyTypeId, counter, frequency, gauge, histogram, isMetricKey, summary, tagged, taggedWithLabelSet, taggedWithLabels };
